import { createPortal } from "react-dom";
import { useRibbonSlot } from "./RibbonSlotContext";
import css from "./TableActionRibbon.module.scss";

export interface TableActionRibbonProps {
    leftActions?: React.ReactElement[];
    rightActions?: React.ReactElement[];
    /**
     * When true the ribbon participates in the sticky page chrome.
     *
     * If a `RibbonSlotContext` host is present (the Scenario Results
     * page) the ribbon's content is portaled into that host, which
     * lives inside a single sticky-chrome parent next to the Tabs nav —
     * the chrome owns the sticky positioning + background, so the
     * ribbon just lays out its actions. With no host (e.g. a standalone
     * sticky table) the ribbon falls back to pinning itself inline via
     * `position: sticky`.
     */
    sticky?: boolean;
}

export const TableActionRibbon: React.FC<TableActionRibbonProps> = ({
    leftActions,
    rightActions,
    sticky
}) => {
    const slot = useRibbonSlot();
    // Only pin inline when sticky AND there is no chrome host to portal
    // into; when hosted, the chrome owns the sticky positioning + bg.
    const inlineSticky = sticky && !slot;
    const className = inlineSticky ? `${css.ribbon} ${css.sticky}` : css.ribbon;
    const ribbon = (
        <div className={className}>
            <div className={css.actions}>{leftActions}</div>
            <div className={css.actions}>{rightActions}</div>
        </div>
    );
    return sticky && slot ? createPortal(ribbon, slot) : ribbon;
};
